export default __webpack_public_path__ + "static/media/screenout_colour.e1ba70c0.svg";